import {
	post,
	get
} from "../util/crmAxios";
import {getBasicUrls} from "../util/config";

// 导入数据-查询导入统计的分页列表
export const queryClueImportList = (params) => post('/crm/clueImport/queryClueImportList', params)
// 导入数据-查询导入统计的分页列表
export const uploadAgentData = (params) => post('/crm/clueImport/uploadAgentData', params)
// 导入数据-查询导入明细的分页列表
export const queryClueImportDetailList = (params) => post('/crm/clueImport/queryClueImportDetailList', params)
// 导入数据-数据入库-确定导入按钮
export const persistData = (params) => post('/crm/clueImport/persistData', params)
// 导入同步，进度条查询
export const getBatchNum = (params) => get('/crm/clueImport/getBatchNum', params)
// 学员查询-es
export const queryCustomerInfo = (params) => post('/crm/search/queryCustomerInfo', params)
// 学员查询-new
export const queryMultiCampusCustomerInfo = (params) => post('/crm/search/queryMultiCampusCustomerInfo', params)
// 线索列表查询-全部线索、我的线索、公有池、回收站
export const queryMultiCampusCustomerInfoV2 = (params) => post('/crm/customManage/queryMultiCampusCustomerInfo', params)
// 来源
export const getChannelList = (params) => get('/crm/channel/getChannelList', params)
// 来源
export const getTodayFollowCount = (params) => get('/crm/customerfollow/getTodayFollowCount', params)
// 新增客户邀约
//export const addCustomInvite = (params) => post('/crm/invite/addCustomInvite', params)
export const addCustomInvite = (params) => post('/crm/invite/addAgentCustomInvite', params)
// 代理商-新增客户邀约-邀约大体检
export const addAgentCustomInvite = (params) => post('/crm/invite/addAgentCustomInvite', params)
// 标记学员为潜在学员
export const markingLatentForCustom = (params) => post('/crm/customerfollow/markingLatentForCustom', params)
// 获取模板文件下载地址
export const getTemplateDownloadUrl = (params) => post('/crm/clueImport/getTemplateDownloadUrl', params)
// 代理商获取模板文件下载地址
export const getAgentTemplateDownloadUrl = (params) => post('/crm/clueImport/getAgentTemplateDownloadUrl', params)
// 报名签名
export const getBuyClassParam = (params) => get('/crm/customer/getBuyClassParam', params)
// 获取首页跳转参数
export const getSchoolIndexParam = (params) => get('/crm/customer/getSchoolIndexParam', params)

// 新增/修改配置
export const addOrUpdatePageListColumnsConfig = (params) => post('/crm/customer/addOrUpdatePageListColumnsConfig', params)

// 查询配置
export const queryPageListColumnsConfig = (params) => get('/crm/customer/queryPageListColumnsConfig', params)
// 超级监课
export const querySupervision = (params) => get('/erp/teacher/querySupervision', params)

// 学员超级督学地址
export const getStudyRoomUrl = (params) => get('/erp/teacherfeedback/getStudyRoomUrl', params)
// 公海池列表
export const queryMultiCampusPoolCustomerInfo = (params) => post('/crm/search/queryMultiCampusPoolCustomerInfo', params)
// 客户放入公海池
export const putCustomPool = (params) => post('/crm/customerfollow/putCustomPool', params)
//订单总金额查询
export const queryOrderAmount = (params) => post('/erp/order/queryOrderAmount', params)
//学习机试听列表
export const queryStudentLearnMachineAuditio = (params) => post('/erp/studentAudition/queryStudentLearnMachineAuditio', params)
// 查询校区基本信息
export const querySchoolInfo = params => get(getBasicUrls().schoolm + '/manage/schoolmove/querySchoolInfo',params)
// 查询校区基本信息
export const saveMoveRequest = params => post(getBasicUrls().schoolm + '/manage/schoolmove/saveMoveRequest',params)
//查询是否能转校
export const checkCanMove = (params) => get('/crm/user/checkCanMove', params);
//待跟进例子查询
export const queryDingLeads = (params) => post('/ding/leads/queryDingLeads', params);
//查询待领取例子
export const queryPubLeads = (params) => post('/ding/leads/queryPubLeads', params);
//例子领取
export const leadsFetch = (params) => post('/ding/leads/leadsFetch', params);
//待领取数量统计
export const queryFetchStaticInfo = (params) => post('/ding/leads/queryFetchStaticInfo', params);
//查询用户作业数据
export const queryHomeworkReport = (params) => post('/ding/leads/queryHomeworkReport', params);
//钉钉例子标注失效/成交
export const markClueStatus = (params) => post('/ding/leads/markClueStatus', params);
//查询手机号明码
export const getPhoneNo = (params) => get('/ding/leads/getPhoneNo', params);

//总部公海池查询
export const leadsPublicList = (params) => post('/crm/leads/leadsPublicList', params);

//今日可领取数量
export const todayCanPickCount = (params) => get('/crm/leads/todayCanPickCount', params);

//例子领取记录
export const leadsPickList = (params) => post('/crm/leadsPick/leadsPickList', params);

//例子领取记录导出
export const exportLeadsPickList = (params) => post('/crm/leadsPick/exportLeadsPickList', params);

//例子回收记录
export const leadsRecycleList = (params) => post('/crm/leadsRecycle/leadsRecycleList', params);

//例子回收记录导出
export const exportLeadsRecycleList = (params) => post('/crm/leadsRecycle/exportLeadsRecycleList', params);

//潜在客户-即将回收数量
export const queryRecycledCount = (params) => post('/crm/search/queryRecycledCount', params);

//批量分配
export const batchAssign = (params) => post('/crm/leads/batchAssign', params);

//批量领取
export const batchPick = (params) => post('/crm/leads/batchPick', params);

//渠道查询
export const querySourceByParentId = (params) => get('/crm/channel/querySourceByParentId', params);

//总部公海池详情
export const queryLeadsPublicPoolInfoById = (params) => post('/crm/leads/queryLeadsPublicPoolInfoById', params);

//获取用户自定义表格信息
export const getTableCustomizeInfo = (params) => get('/crm/table/getTableCustomizeInfo', params) 

//修改用户自定义表格信息
export const modifyTableCustomizeInfo = (params) => post('/crm/table/modifyTableCustomizeInfo', params) 

//查询门店信息
export const queryStoreInfo = (params) => get('/crm/customManage/queryStoreInfo', params) 

//标记线索失效
export const markingFailureForCustom = (params) => post('/crm/customManage/markingFailureForCustom', params) 

//线索释放还原收回
export const customWithdraw = (params) => post('/crm/customManage/customWithdraw', params) 

//意向程度改变
export const updateCustomIntend = (params) => post('/crm/customManage/updateCustomIntend', params) 

//查询跟进提醒
export const queryFollowUpManageRemind = (params) => post('/crm/customManage/queryFollowUpManageRemind', params) 

//取消跟进
export const cancelFollowTask = (params) => post('/crm/customManage/cancelFollowTask', params) 

//跟进管理列表查询
export const queryFollowUpManageList = (params) => post('/crm/customManage/queryFollowUpManageList', params) 

//查询用户线索权限
export const queryUserCluePermission = (params) => get(getBasicUrls().crm +'crm/customManage/getUserCustomPermission', params);
// 订阅卡流水小红点阅读
export const readRedDot = (params) => get(getBasicUrls().schoolm +'manage/agent/recharge/readRedDot', params);

// 订阅卡流水小红点状态
export const redDotCheck = (params) => get(getBasicUrls().schoolm +'manage/agent/recharge/redDotCheck', params);


// 查询订阅卡是否过期
export const getInvitevalidityByTime = (params) => post(getBasicUrls().schoolm +'manage/machine/getinvitevaliditybytime', params);


//潜在客户-禁止填入的虚拟号段前缀
export const virtualPhoneSegments = (params) => get(getBasicUrls().baseUrl +'/agentcrm/customer/virtualphonesegments', params) 


//查询分析师列表
export const queryTeacherManagerList = (params) => post('/erp/teacher/teachermanagelist', params)

//分析师学生列表-查看学生列表
export const queryTeacherStudentList = (params) => post('/erp/teacher/teacherstudnetlist', params)

//分析师学生列表-添加学生列表
export const queryTeacherOtherStudentList = (params) => post('/erp/teacher/teacherotherstudnetlist', params)

//分析师学生列表批量移除学生
export const batchRemoveStudents = (params) => post('/erp/teacher/batchremovestudents', params)

//分析师学生列表批量添加学生
export const batchAddStudents = (params) => post('/erp/teacher/batchaddstudents', params)

// 查询手机号前缀
export const getPhonePrefixList = (params) => get(getBasicUrls().baseUrl +'/agentcrm/dictionary/getPhonePrefixList', params) 

